import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  getData: (
    url: string,
    invoiceNumber: string,
    serviceNo: string,
    serviceId: number,
    ebillSection?: string,
    ebillGroup?: string,
    ebillOrigNo?: string,
    ebillTermNo?: string,
    ebillOrderBy?: string,
    summaryGroupCode?: string,
    summaryChargeCode?: string,
    posNext?: number,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/detail-record/getData`, {
      params: {
        invoicenumber: invoiceNumber,
        serviceno: serviceNo,
        serviceid: serviceId,
        ebillSection: ebillSection,
        ebillGroup: ebillGroup,
        ebillOrigNo: ebillOrigNo,
        ebillTermNo: ebillTermNo,
        ebillOrderBy: ebillOrderBy,
        summaryGroupCode: summaryGroupCode,
        summaryChargeCode: summaryChargeCode,
        posNext: posNext,
        pageSize: pageSize,
      },
    }),
  lazyload: (
    url: string,
    invoiceNumber: string,
    serviceNo: string,
    serviceId: number,
    ebillSection?: string,
    ebillGroup?: string,
    ebillOrigNo?: string,
    ebillTermNo?: string,
    ebillOrderBy?: string,
    summaryGroupCode?: string,
    summaryChargeCode?: string,
    posNext?: number,
    pageSize?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/detail-record/lazyload`, {
      params: {
        invoicenumber: invoiceNumber,
        serviceno: serviceNo,
        serviceid: serviceId,
        ebillSection: ebillSection,
        ebillGroup: ebillGroup,
        ebillOrigNo: ebillOrigNo,
        ebillTermNo: ebillTermNo,
        ebillOrderBy: ebillOrderBy,
        summaryGroupCode: summaryGroupCode,
        summaryChargeCode: summaryChargeCode,
        posNext: posNext,
        pageSize: pageSize,
      },
    }),
};
